<template>
  <div>
    <Row :gutter="8" class="m-b-10">
      <i-col span="3">
        <DatePicker
          v-model="dateRange"
          :transfer="true"
          type="daterange"
          size="small"
          placement="bottom-end"
          placeholder="选择起止日期"
          style="width: 100%"
        ></DatePicker>
      </i-col>
      <i-col span="4">
        <Input
          v-model="query.keyword"
          size="small"
          placeholder="关键字：名称"
        />
      </i-col>
      <i-col span="2">
        <Button type="primary" icon="ios-search" size="small" @click="onSearch"
          >搜索</Button
        >
      </i-col>
    </Row>
    <div class="m-b-10">
      <Button
        type="success"
        size="small"
        icon="ios-cloud-upload-outline"
        class="m-r-5"
        @click="onUploadFile"
        >导入文件</Button
      >
      <Button type="info" size="small" class="m-r-5" @click="onViewRecords"
        >导入记录</Button
      >
    </div>
    <Table
      stripe
      max-height="720"
      size="small"
      :data="list"
      :columns="tableColumns"
      :loading="tableLoading"
    >
    </Table>
    <div class="paging_style">
      <Page
        size="small"
        :total="total"
        :page-size="query.pageSize"
        show-total
        show-elevator
        show-sizer
        :page-size-opts="pagesizeSetting"
        @on-page-size-change="onChangePageSize"
        :current="query.pageNumber"
        @on-change="onChangePageNum"
      ></Page>
    </div>
    <upload-file ref="uploadFileRef" @onSuccess="onSearch" />
    <upload-records ref="uploadRecordsRef" />
  </div>
</template>

<script>
import { ParseDate } from '@/utils/dateFormat'
import { getPlayList } from '@/api/msp/playList'

import UploadFile from './UploadFile.vue'
import UploadRecords from './UploadRecords.vue'
export default {
  components: { UploadFile, UploadRecords },
  data () {
    return {
      pagesizeSetting: [15, 50, 100, 200, 500],
      dateRange: [],
      query: {
        pageNumber: 1,
        pageSize: 15,
        startDate: '',
        endDate: '',
        keyword: ''
      },
      list: [],
      total: 0,
      tableLoading: false,
      tableColumns: [
        { title: '开始时间', align: 'center', minWidth: 120, key: 'startTime' },
        { title: '结束时间', align: 'center', minWidth: 120, key: 'endTime' },
        { title: '时长', align: 'center', minWidth: 120, key: 'duration' },
        { title: '名称', align: 'center', minWidth: 120, key: 'name' },
        { title: '类型', align: 'center', minWidth: 120, key: 'typeName' },
        { title: '模板', align: 'center', minWidth: 120, key: 'sizes' },
        {
          title: '冷静时间',
          align: 'center',
          minWidth: 120,
          key: 'pauseLength'
        },
        { title: '客户名称', align: 'center', minWidth: 120, key: 'advertiserName' },
        { title: '开始日期', align: 'center', minWidth: 120, key: 'startDate' },
        { title: '结束日期', align: 'center', minWidth: 120, key: 'endDate' },
        {
          title: '状态',
          align: 'center',
          minWidth: 120,
          key: 'playStatusName'
        }
      ]
    }
  },
  mounted () {
    this.getTableData()
  },
  methods: {
    getTableData () {
      this.tableLoading = true
      getPlayList(this.query)
        .then((res) => {
          if (res && !res.errcode) {
            this.list = res.list
            this.total = res.totalRow
          } else {
            this.list = []
            this.total = 0
          }
        })
        .finally(() => {
          this.tableLoading = false
        })
    },
    onSearch () {
      this.query.startDate =
        this.dateRange.length && this.dateRange[0] !== '' ? ParseDate(this.dateRange[0]) : ''
      this.query.endDate =
        this.dateRange.length && this.dateRange[1] !== '' ? ParseDate(this.dateRange[1]) : ''
      this.query.pageNumber = 1
      this.getTableData()
    },
    onChangePageSize (curPageSize) {
      this.query.pageSize = curPageSize
      this.query.pageNumber = 1
      this.getTableData()
    },
    onChangePageNum (curPage) {
      this.query.pageNumber = curPage
      this.getTableData()
    },
    onUploadFile () {
      this.$nextTick(() => {
        this.$refs.uploadFileRef.show()
      })
    },
    onViewRecords () {
      this.$nextTick(() => {
        this.$refs.uploadRecordsRef.show()
      })
    }
  }
}
</script>
